// GENERATED FILE - DO NOT EDIT

// This file has been automatically generated. Any modifications made to this file will be overwritten the next time it is regenerated. Please refrain from editing this file directly.

/** Monaco */
const MC = /^(?:4(?:[46]\d|5[1-9])\d{5}|(?:3|[67]\d)\d{7})$/;

export default MC;
